import { render, staticRenderFns } from "./TypeCriticalityForm.vue?vue&type=template&id=9cc3b11c&"
import script from "./TypeCriticalityForm.vue?vue&type=script&lang=js&"
export * from "./TypeCriticalityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports